import React, { useEffect, useState } from "react";
import styles from "./PropertyTaskList.module.css";
import { Edit2, Lock, MoreVertical, Plus, Trash2, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import Loader from "../../../../../../components/Loader";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Dropdown } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const PropertyTaskList = (props) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [newTaskName, setNewTaskName] = useState("");
  const [isShowInlineEdit, setShowInlineEdit] = useState(false);
  const [isShowAddAction, setShowAddAction] = useState(false);
  const [editTaskData, setEditTaskData] = useState(null);
  const [openTaskDeleteModal, setOpenTaskDeleteModal] = useState(false);
  const [deleteTaskId, setDeleteTaskId] = useState(0);
  const [charsLeft, setCharsLeft] = useState(200);

  useEffect(() => {
    if (props?.task_list) {
      let taskListTemp = props?.task_list?.map((i) => {
        return { id: i?.id, task_name: i?.task_name, is_primary: i?.is_primary, order: i?.order, property_id: i?.property_id };
      });

      setTaskList(taskListTemp);
    }
  }, [props?.task_list]);

  const addNewTask = async () => {
    if (newTaskName === "") {
      toast.error("Please enter task name.");
      return false;
    }
    setShowInlineEdit(false);
    setShowAddAction(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const propertyId = props?.property_id;

    if (editTaskData) {
      axios.put(process.env.REACT_APP_PROPERTY_API_URL + `v1/properties/${propertyId}/task-list/` + editTaskData?.id, { task_name: newTaskName }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setLoading(false);
        let respData = response.data.data;

        let newTaskList = taskList?.map((i) => {
          if (i?.id === editTaskData?.id) {
            return respData;
          }
          return i;
        });

        props.setPropertyData((prev) => {
          return { ...prev, task_list: newTaskList };
        });

        setNewTaskName("");
        setEditTaskData(null);

        props?.setSnackbarMsg(response.data.message);
        props?.setSnackbarOpen(true);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
    } else {
      axios.post(process.env.REACT_APP_PROPERTY_API_URL + `v1/properties/${propertyId}/task-list`, { task_name: newTaskName }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setLoading(false);
        let respData = response.data.data;

        props.setPropertyData((prev) => {
          return { ...prev, task_list: [...prev?.task_list, respData] };
        });

        setNewTaskName("");
        props?.setSnackbarMsg(response.data.message);
        props?.setSnackbarOpen(true);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
    }
  };

  const removeTask = async () => {
    setLoading(true);
    setOpenTaskDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const propertyId = props?.property_id;

    axios.delete(process.env.REACT_APP_PROPERTY_API_URL + `v1/properties/${propertyId}/task-list/` + deleteTaskId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      props.setPropertyData((prev) => {
        return { ...prev, task_list: prev?.task_list.filter((task) => task.id !== deleteTaskId) };
      });

      props?.setSnackbarMsg(response.data.message);
      props?.setSnackbarOpen(true);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(taskList, result.source.index, result.destination.index);

    setTaskList(items);
  };

  useEffect(() => {
    const handler = setTimeout(async () => {
      let newTaskList = taskList?.map((i) => {
        return { id: i?.id };
      });
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      if (newTaskList?.length > 0) {
        axios.post(process.env.REACT_APP_PROPERTY_API_URL + "v1/change-tasklist-order", { data: JSON.stringify(newTaskList) }, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }).then((response) => {
          console.log("Success");
        }).catch((error) => {
          console.log("Error");
        });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [taskList, getAccessTokenSilently]);

  return (<>
    {loading && <Loader />}

    <div className={`${styles.TaskTabCardAccoRow}`}>
      <div className={`${styles.ProspectTaskTable} ProspectTaskTable`}>
        <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <table {...provided.droppableProps} ref={provided.innerRef}>
                <tbody>
                  {taskList && taskList.map((item, index) => (<Draggable key={"item-" + item.id} draggableId={"item-" + item.id} index={index}>
                    {(provided, snapshot) => (
                      <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <td>
                          {(!isShowInlineEdit || item?.id !== editTaskData?.id) && (<>
                            <div className={`${styles.tasklistRow}`}>
                              <div>
                                <p onClick={(e) => {
                                  if (item?.is_primary) { return; }
                                  setShowInlineEdit(true);
                                  setShowAddAction(false);
                                  setEditTaskData(item);
                                  setNewTaskName(item?.task_name);
                                  setCharsLeft(200 - item?.task_name?.length);
                                }}>
                                  {item?.task_name}
                                </p>
                              </div>
                            </div>
                            {item?.is_primary === 1 && (<Lock className={`${styles.TaskListLockIcon}`} />)}
                            {item?.is_primary !== 1 && (<Dropdown className={`${styles.ProEditSec} ${styles.Table}`}>
                              <Dropdown.Toggle className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`} id="dropdown-basic">
                                <MoreVertical />
                              </Dropdown.Toggle>

                              <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setShowInlineEdit(true); setShowAddAction(false); setEditTaskData(item); setNewTaskName(item?.task_name); setCharsLeft(200 - item?.task_name?.length); }}>
                                  <Edit2 /> Edit
                                </Dropdown.Item>
                                {taskList?.length > 2 && (<Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setOpenTaskDeleteModal(true); setDeleteTaskId(item?.id); }}>
                                  <Trash2 /> Delete
                                </Dropdown.Item>)}
                              </Dropdown.Menu>
                            </Dropdown>)}
                          </>)}
                          {isShowInlineEdit && item?.id === editTaskData?.id && (<div className={`${styles.EditActionSec}`}>
                            <div className={`${styles.EditActionFormSec} FormGroup`}>
                              <TextField
                                id="outlined-basic"
                                label="Task Name"
                                variant="outlined"
                                value={newTaskName}
                                onChange={(e) => {
                                  setNewTaskName(e.target.value);
                                  setCharsLeft(200 - e.target.value.length);
                                }}
                                inputProps={{ maxLength: 200 }}
                              />
                              <p className={`${styles.RemainingText}`}>{charsLeft > 1 ? charsLeft + " characters remaining" : charsLeft + " character remaining"}</p>
                            </div>
                            <div className={`${styles.EditActionButtonSec}`}>
                              <button className={`${styles.EditActionButtonUpdate}`} onClick={(e) => { addNewTask(); }}>Update</button>
                              <button className={`${styles.EditActionButtonCancel}`} onClick={(e) => { setShowInlineEdit(false); }}>Cancel</button>
                            </div>
                          </div>)}
                        </td>
                      </tr>)}
                  </Draggable>))}
                  {isShowAddAction && (<tr>
                    <td>
                      <div className={`${styles.EditActionSec}`}>
                        <div className={`${styles.EditActionFormSec} FormGroup`}>
                          <TextField
                            id="outlined-basic"
                            label="Task Name"
                            variant="outlined"
                            value={newTaskName}
                            onChange={(e) => {
                              setNewTaskName(e.target.value);

                              setCharsLeft(200 - e.target.value.length);
                            }}
                            inputProps={{ maxLength: 200 }}
                          />
                          <p className={`${styles.RemainingText}`}>{charsLeft > 1 ? charsLeft + " characters remaining" : charsLeft + " character remaining"}</p>
                        </div>
                        <div className={`${styles.EditActionButtonSec}`}>
                          <button className={`${styles.EditActionButtonUpdate}`} onClick={(e) => { addNewTask(); }}>Add</button>
                          <button className={`${styles.EditActionButtonCancel}`} onClick={(e) => { setShowInlineEdit(false); setShowAddAction(false); }}>Cancel</button>
                        </div>
                      </div>
                    </td>
                  </tr>)}
                  {provided.placeholder}
                  {taskList?.length < 20 && (<tr>
                    <td className={`${styles.AddChecklistTD}`}>
                      <button className={`${styles.AddChecklistBu}`} onClick={(e) => { setEditTaskData(null); setNewTaskName(""); setShowInlineEdit(false); setShowAddAction(true); setCharsLeft(200); }}><Plus /> Add a task</button>
                    </td>
                  </tr>)}
                </tbody>
              </table>)}
          </Droppable>
        </DragDropContext>
      </div>
    </div>

    <Dialog
      open={openTaskDeleteModal}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      onClose={(e) => {
        setOpenTaskDeleteModal(false);
        setDeleteTaskId(0);
      }}
    >
      <DialogTitle id="alert-dialog-title">
        Delete Task
        <button onClick={(e) => { setOpenTaskDeleteModal(false); setDeleteTaskId(0); }}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="ModalFormGroup"
          style={{ marginBottom: "0px", padding: "25px 0" }}
        >
          <label className="PopupBodyText">Are you sure you want to delete this item?</label>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => { removeTask(); }}>Delete</Button>
        <Button className="SubmitPopupBU" onClick={(e) => { setOpenTaskDeleteModal(false); setDeleteTaskId(0); }}>Cancel</Button>
      </DialogActions>
    </Dialog>
  </>);
};

export default PropertyTaskList;